module.exports = "https://cdn.realtymogul.com/static/media/IDP_process.7229e37d.jpg";